// extracted by mini-css-extract-plugin
module.exports = {"navMenu":"NavMenu_navMenu__Iy5JH","main":"NavMenu_main__1QK_B","sub":"NavMenu_sub__2yCBx","privacy":"NavMenu_privacy__3S8lh","link":"NavMenu_link__2nESy"};